export default function HelloWorld() {
  return <h1>Hello, World!</h1>;
}